import { isNil } from 'lodash-es';

import { isSearchPhraseSuggestion } from '../../modules/SearchBar/SearchBar.utils';
import type { Suggestion } from '../../modules/SearchBar/types';
import { generateGraphPatternCypher } from '../../state/search/suggestions/graph-pattern-suggestions/graph-pattern-suggestions.query';
import type { TransformedSearchCategory } from '../../types/perspective';
import { SearchErrors } from '../errors/errors';

export const checkCypherUpdateClauses = (query: string) =>
  !!query.match(/((^[.]*)|(\r\n|\r|\n|\s))(CREATE|DELETE|SET|REMOVE|MERGE)((^[.]*)|(\r\n|\r|\n|\s))/gim);

export const generateCypher = async ({
  lockedSuggestions,
  categories,
  visibleRelationshipTypes,
  isCaseInsensitive,
  isHttpQueryApiEnabled,
}: {
  lockedSuggestions: Suggestion[];
  categories: TransformedSearchCategory[];
  visibleRelationshipTypes: string[];
  isCaseInsensitive: boolean;
  isHttpQueryApiEnabled: boolean;
}) => {
  const searchPhraseSuggestion = lockedSuggestions.find(isSearchPhraseSuggestion);
  if (!isNil(searchPhraseSuggestion)) {
    if (searchPhraseSuggestion.hasCypherErrors || !searchPhraseSuggestion.query?.cypher) {
      throw SearchErrors.SearchPhraseInvalid;
    }

    if (!searchPhraseSuggestion.complete) {
      throw SearchErrors.SearchPhraseMissingParams;
    }

    return {
      cypher: searchPhraseSuggestion.query?.cypher,
      params: searchPhraseSuggestion.query?.parameters ?? {},
    };
  }

  const generatedCypher = generateGraphPatternCypher(
    lockedSuggestions,
    categories,
    visibleRelationshipTypes,
    isCaseInsensitive,
    isHttpQueryApiEnabled,
  );

  if (!generatedCypher) {
    throw SearchErrors.GeneratedCypherError;
  }
  return generatedCypher;
};
